<div [formGroup]="group">
	<button
		style="width: 100%; font-weight: bolder"
		color="primary"
		type="submit"
		mat-button>
		{{ config.label }}
	</button>
</div>
